module.exports = __webpack_public_path__ + "static/media/dispatched.a1dce409.svg";


//////////////////
// WEBPACK FOOTER
// /src/assets/icons/dispatched.svg
// module id = ./src/assets/icons/dispatched.svg
// module chunks = 0